import { useEffect, useState } from "react";

import { db } from "../firebase/config";

const useSpeaker = (speakerID?: string) => {
  const [speaker, setSpeaker] = useState<any>();

  useEffect(() => {
    if (speakerID) {
      const fetch = async () => {
        const speakerRef = await db.collection("speakers").doc(speakerID).get();
        const speakerData = speakerRef.data();
        setSpeaker(speakerData);
      };

      fetch();
    }
  }, [speakerID]);

  return speaker;
};

export default useSpeaker;
